
import {
  ENTITY_TYPES_MAP,
  BATCH_PROCESSING_EXCLUDED_FIELDS,
} from "./constants";

/**
 * Resets a specific property of a field within a section list of Form Editor.
 * @param {Array} sectionList - The list of sections containing fields.
 * @param {Object} field - The field object to update.
 * @param {Object} config - Configuration object containing property and value.
 */
export const resetFieldProp = (sectionList, field, config = {}) => {
  const { property, resetValue = null } = config;

  if (!property) return;

  const setFieldProp = (el) => {
    if (el.id === field.id) {
      el[property] = resetValue;
    }
    return el;
  };

  sectionList.forEach((section) => {
    section.fields = section.fields.map((el) => {
      if (el.field_entity_type === ENTITY_TYPES_MAP.FIELD) {
        return setFieldProp(el);
      } else if (el.field_entity_type === ENTITY_TYPES_MAP.BLOCK) {
        return {
          ...el,
          fields: el.fields.map((blockField) => setFieldProp(blockField)),
        };
      }
      return el;
    });
  });
};

export const isBatchProcessingAllowed = (field) => {
  if (!field?.type) {
    return true;
  }
  return !BATCH_PROCESSING_EXCLUDED_FIELDS
    .map((el) => el.toLowerCase())
    .includes(field.type.toLowerCase());
}